var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHaze(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100.000000pt",
    height: "100.000000pt",
    viewBox: "0 0 100.000000 100.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
    fill: "lightskyblue",
    stroke: "lightskyblue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390 650 c0 -6 35 -10 85 -10 50 0 85 4 85 10 0 6 -35 10 -85 10 -50 0 -85 -4 -85 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348 583 c45 -2 119 -2 165 0 45 1 8 3 -83 3 -91 0 -128 -2 -82 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 520 c0 -6 68 -10 184 -10 113 0 187 4 191 10 4 7 -60 10 -184 10 -121 0 -191 -4 -191 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 460 c0 -6 70 -10 190 -10 120 0 190 4 190 10 0 6 -70 10 -190 10 -120 0 -190 -4 -190 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 400 c0 -6 70 -10 190 -10 120 0 190 4 190 10 0 6 -70 10 -190 10 -120 0 -190 -4 -190 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 340 c0 -6 47 -10 120 -10 73 0 120 4 120 10 0 6 -47 10 -120 10 -73 0 -120 -4 -120 -10z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaze);
export default __webpack_public_path__ + "static/media/haze.810ea7df1f754d9a5e1ac4f7ccad2980.svg";
export { ForwardRef as ReactComponent };